<div class="tournamentsCon" [ngStyle]="  { 'text-align' : direction =='ar'?'right' :'left' ,'direction' : direction =='ar'?'rtl' :'ltr' }">
  <!--    <div class="items" *ngFor="let tournament of (eventService.eventTournaments|async)?.data">-->

  <!--      <div class="items-status" [ngClass]="{'active':tournament.status=='Waiting Players to Join',-->
  <!--                                  'finished':tournament.status=='Finished', 'inprogress':tournament.status=='In Progress'}"></div>-->
  <a class="tournamentCard"
     href="https://www.gbarena.com/tournaments/{{ tournament.code }} "
  >
    <div class="topBanner">
            <img src="{{tournament?.cover_picture}}" class="img-responsive" >
<!--      <img src="../../../../../assets/img/tecno-cup-ksa/tecno-banner.jpg" class="img-responsive" >-->
    </div>
    <div class="body" [style]="styleExpression">
      <h1>{{ tournament.name }}</h1>
      <div class="midCon">
        <div class="date">
          <div class="item">
            <svg xmlns="http://www.w3.org/2000/svg" width="14.55" height="16.628" [style]="styleExpressionSvg">
              <path data-name="Icon awesome-calendar-alt" d="M0 15.069a1.559 1.559 0 0 0 1.559 1.559h11.432a1.559 1.559 0 0 0 1.559-1.559V6.236H0zM10.393 8.7a.391.391 0 0 1 .39-.39h1.3a.391.391 0 0 1 .39.39V10a.391.391 0 0 1-.39.39h-1.3a.391.391 0 0 1-.39-.39zm0 4.157a.391.391 0 0 1 .39-.39h1.3a.391.391 0 0 1 .39.39v1.3a.391.391 0 0 1-.39.39h-1.3a.391.391 0 0 1-.39-.39zM6.236 8.7a.391.391 0 0 1 .39-.39h1.3a.391.391 0 0 1 .39.39V10a.391.391 0 0 1-.39.39h-1.3a.391.391 0 0 1-.39-.39zm0 4.157a.391.391 0 0 1 .39-.39h1.3a.391.391 0 0 1 .39.39v1.3a.391.391 0 0 1-.39.39h-1.3a.391.391 0 0 1-.39-.39zM2.079 8.7a.391.391 0 0 1 .39-.39h1.3a.391.391 0 0 1 .39.39V10a.391.391 0 0 1-.39.39h-1.3a.391.391 0 0 1-.39-.39zm0 4.157a.391.391 0 0 1 .39-.39h1.3a.391.391 0 0 1 .39.39v1.3a.391.391 0 0 1-.39.39h-1.3a.391.391 0 0 1-.39-.39zM12.991 2.079h-1.559V.52a.521.521 0 0 0-.52-.52H9.873a.521.521 0 0 0-.52.52v1.559H5.2V.52A.521.521 0 0 0 4.677 0h-1.04a.521.521 0 0 0-.52.52v1.559H1.559A1.559 1.559 0 0 0 0 3.637V5.2h14.55V3.637a1.559 1.559 0 0 0-1.559-1.558z" />
            </svg>


            {{tournament.start_at | date:'d/M/yy'}}</div>
          <div class="item">
            <svg xmlns="http://www.w3.org/2000/svg" width="16.574" height="16.574" [style]="styleExpressionSvg">
              <path data-name="Icon awesome-clock" d="M8.85.563a8.287 8.287 0 1 0 8.287 8.287A8.286 8.286 0 0 0 8.85.563zm1.908 11.7L7.81 10.119a.4.4 0 0 1-.163-.319V4.171a.4.4 0 0 1 .4-.4h1.6a.4.4 0 0 1 .4.4v4.6l2.122 1.544a.4.4 0 0 1 .087.561l-.942 1.3a.4.4 0 0 1-.556.085z" transform="translate(-.563 -.563)" />
            </svg>
            {{tournament.start_at | date:'shortTime'}}</div>
        </div>
        <div class="status" style="display: flex; justify-content: flex-start; align-items: center;">

          <div class="icon"
               [ngClass]="{'active':tournament.status=='Waiting Players to Join',
                                  'finished':tournament.status=='Finished', 'inprogress':tournament.status=='In Progress',
                                  'closed':tournament.status=='Registration Closed'}"></div>

          <p *ngIf="tournament.status=='Waiting Players to Join'">{{globalService?.customLang?.open? globalService?.customLang?.open : 'Open'}}</p>
          <p *ngIf="tournament.status=='In Progress'">{{globalService?.customLang?.in_progress ? globalService?.customLang?.in_progress : 'In Progress'}}</p>
          <p *ngIf="tournament.status=='Finished'">{{globalService?.customLang?.Finished? globalService?.customLang?.Finished : 'Finished'}}</p>
          <p *ngIf="tournament.status=='Registration Closed'">{{globalService?.customLang?.Registration_Closed? globalService?.customLang?.Registration_Closed : 'Registration closed'}}</p>

        </div>
      </div>

    </div>
  </a>

</div>
